
import externalConfiguration from '../external-configuration';
import { avoidCache, patchM3u8Url, isIE11, IE11_safeIncludes, IE11_safeFrameElement } from './utils';

function playerReadData( settings, player) {
  const color = parseInt( player.settings.controls.color.replace('0x', ''), 16);
  const alpha = player.settings.controls.alpha;
  Object.assign( settings.customProps, {
    autostart: player.settings.autoplay,
    skin: {        // TODO: Esto deberia parametrizarse en admin player, y referenciar skins auto-alojados
    	name: 'glow',
    	active: '#666666',
    	inactive: '#aaaaaa',
    	background: 'rgba(' + ((color >> 16) & 255) + ', ' + ((color >> 8) & 255) + ', ' + (color & 255) + ', ' + alpha + ')',
    },
  });
  if( player.settings.controls.share.visible === 'true') {   // Este bloque construye la seccion de compartir si es necesario
    let code = IE11_safeFrameElement();
    if( !code) {
      code = '<iframe src="' + document.URL + '"></iframe>';
    }
    let networks = player.settings.controls.share.network;
    let keys = Object.keys(networks);
    let sites = [];
    for (let i = 0; i < keys.length; i++) {
      let site = keys[i];
      if( networks[site] && networks[site] !== 'false'){
        if( site === 'google') {
          site = 'googleplus';
        } else if (site === 'mail') {
          site = 'email';
        } else {
          site = site.toLowerCase();
        }
        sites[i] = site;
      }
    }
    settings.customProps.sharing = {
      code,
      link: /src=["']([^"']*)["']/.exec(code)[1],
      sites,
    };
  }
  // if( player.settings.logo.visible === 'true')) {  // Este bloque construye la seccion del logo si es necesario
  let src = player.settings.logo.src;
  if( src !== '') {
    const positions = [ 'top-left', 'top-left', 'top-right', 'bottom-left', 'top-right', 'bottom-left', 'bottom-right', 'bottom-right'];
    settings.customProps.logo = {
      file: avoidCache( src),
      link: avoidCache( player.settings.logo.url),
      position: positions[ parseInt( player.settings.logo.pos, 10)],
    };
  }
  if( !IE11_safeIncludes( [ 'live', 'vod'], player.type.toLowerCase())) {
    console.error( 'Unknown player type: ', player.type);
  }
  settings.visualizerOptions.srcType = player.type.toLowerCase();
  settings.playlist = [{  // Esta playlist sera el elemento reproducible, si es live; si es vod, solo el campo 'adschedule' contiene informacion valida
    image: avoidCache( player.prevPic),
    file: patchM3u8Url( player.streamOrigin),
  }];
  let pre = player.settings.ads.pre_roll;    // Este bloque construye la seccion de publicidad si es necesario
	let mid = player.settings.ads.mid_roll;
	let post = player.settings.ads.post_roll;
	let pre_skip = player.settings.ads.pre_skip;
	let mid_skip = player.settings.ads.mid_skip;
  let post_skip = player.settings.ads.post_skip;
  let advertising = {
    client: 'vast',
  };
  let adschedule = {}
	if( pre !== undefined && pre !== '' && pre !== 'false') {
    adschedule.adbreak1 = {
      offset: 'pre',
      tag: pre,
      skipoffset: pre_skip,
    };
	}
	if( mid !== undefined && mid !== '' && mid !== 'false') {
    adschedule.adbreak2 = {
      offset: '50%',
      tag: mid,
      skipoffset: mid_skip,
    };
	}
  if( post !== undefined && post !== '' && post !== 'false') {
    adschedule.adbreak3 = {
      offset: "post",
      tag: post,
      skipoffset: post_skip,
    };
  }
  if( Object.keys( adschedule).length !== 0) {
    settings.customProps.advertising = advertising;
    settings.playlist[0].adschedule = adschedule;
  }
  settings.debug = {
    imageFromPlayerPrevPic: player.prevPic,
    imageFromPlayerXMLVidPic: player.settings.controls.vidPic,
    fileFromPlayerSrc: player.src,
    fileFromPlayerSrcMobile: player.srcMobile,
  };
  settings.basePlayerOptions = { download: player.settings.controls.share.download };
  return settings;
}

function restrictionsReadData( settings, accessControl) {
  settings.playbackRestrictions = {
    domainBlockActive: accessControl.domains.length !== 0,
    domainsBlocked: accessControl.domains,
    countryBlockActive: Object.keys( accessControl.regions).length !== 0,
    countriesBlocked: accessControl.regions,
    displayImageWhenBlock: externalConfiguration.defaultBlockImage,   // accessControl.img,    // una vez que se le configure un valor valido
  };
  return settings;
}

function playerToState( id, user) {
  let settings = {
    legacy: true,
    customProps: {
      hlshtml: true,
      primary: isIE11() ? 'flash' : 'html5',
      abouttext: externalConfiguration.defaultPlayerAboutText,
      aboutlink: externalConfiguration.defaultPlayerAboutLink,
      width: window.innerWidth,
      height: window.innerHeight,
      // advertising: { client: 'vast', },    // REVIEW: Si los anuncios val ligados al player se setean o no en playerReadData; Revisar para playlist
    },
    visualizerOptions: {
      onResize: ( state) => { state.customProps.width = window.innerWidth; state.customProps.height = window.innerHeight; return state;},
    },
  };
  return fetch( avoidCache( '/definition/vdmplayers/' + user + '/' + id + '.json'))
  .then( response => response.json())
  .then( player => {
    settings = restrictionsReadData( settings, player.accessControl);
    settings = playerReadData( settings, player);
    return settings;
  });
}

export default playerToState;



// WEBPACK FOOTER //
// ./src/helpers/player-to-state.js